// @flow
import {Next} from "../MiddlewareUtils";
import type {Store} from "redux";
import type {Dispatch} from "redux";
import type {Action} from "../../Ducks/DucksUtils";
import type {GetState} from "../../Store";

const actionsToMiddlemanFor = {};

export type MiddlemanHandler = (...rest: Array<void>) => (dispatch: Dispatch, getState: GetState) => mixed;

/**
 * Add an action/handler pair to the middleware middleware
 * @param key: string
 * @param handler: Function that accepts zero arguments
 */
export const registerMiddleman = (key: string, handler: MiddlemanHandler) => {
    if (actionsToMiddlemanFor[key]) {
        throw new Error("Tried registering an already existing handler");
    }
    actionsToMiddlemanFor[key] = handler;
};

/**
 * When used as a middleware, whenever a registered action is dispatched, the corresponding handling will be invoked
 * @param store: Store
 * @returns {function(Next): Function}
 */
const middleware = (store: Store) => (next: Next) => (action: Action) => {
    const dispatch = store.dispatch;
    if (!action || !actionsToMiddlemanFor.hasOwnProperty(action.type)) {
        return next(action);
    }
    return dispatch(actionsToMiddlemanFor[action.type]());
};

export default middleware;


// WEBPACK FOOTER //
// ./src/Store/Middleware/Middleman/middleware.js